<template>
  <div id="app">
    <div class="container">
      <div class="main">
        <main-navigation />
        <songs-list :songs="songs" />
      </div>
      <app-footer />
      <modal v-if="showModal" @close="closePopup" />
      <greetings-modal v-if="showGreetingModal" @close="closeGreetingPopup" />
    </div>
    <floating-tooltip />
    <tracking />
  </div>
</template>

<script>

import "./assets/share.jpg"
import MainNavigation from "./components/MainNavigation";
import SongsList from "./components/SongsList";
import AppFooter from "./components/AppFooter";
import Modal from "./components/Modal";
import GreetingsModal from "./components/GreetingsModal";
import FloatingTooltip from "./components/FloatingTooltip";
import Tracking from "./components/Tracking";

export default {
  name: 'App',
  data() {
    return {
      songs: [],
      showModal: this.$route.matched[0]?.props?.default?.modal || false,
      showGreetingModal: this.$route.matched[0]?.props?.default?.greetingModal || false,
    }
  },
  components: {
    AppFooter,
    MainNavigation,
    SongsList,
    Modal,
    GreetingsModal,
    FloatingTooltip,
    Tracking
  },
  watch: {
    $route(to) {
      this.showModal = to.matched[0]?.props?.default?.modal || false;
      this.showGreetingModal = to.matched[0]?.props?.default?.greetingModal || false;
    }
  },
  mounted() {

  },
  methods: {
    closePopup() {
      this.showModal = false;
    },
    closeGreetingPopup() {
      this.showGreetingModal = false;
    }
  }
}
</script>

<style lang="scss">
 @import "style/main.scss";
</style>